// Beregner reell månedlig lønnskostnad (brutto + arbeidsgiveravgift +
// feriepenger + OTP) for faste utgifter-budsjettet. Fastlønn kan ha en
// stillingsprosent som endrer seg over tid (gradvis opptrapping), derfor
// beregnes prosenten som gjaldt 1. i den aktuelle måneden ut fra historikken.

export function stillingsprosentForManed(ansatt, year, monthIndex) {
  const historikk = ansatt?.stillingsprosentHistorikk || [];
  const forsteIManeden = new Date(year, monthIndex, 1);
  let gjeldende = 0;
  for (const endring of historikk) {
    const dato = new Date(endring.gjeldendeFra);
    if (dato <= forsteIManeden) gjeldende = Number(endring.stillingsprosent) || 0;
  }
  return gjeldende;
}

function erAktivIManed(ansatt, year, monthIndex) {
  const forsteIManeden = new Date(year, monthIndex, 1);
  const sisteIManeden = new Date(year, monthIndex + 1, 0);
  if (ansatt?.startdato && new Date(ansatt.startdato) > sisteIManeden) return false;
  if (ansatt?.sluttdato && new Date(ansatt.sluttdato) < forsteIManeden) return false;
  return true;
}

export function bruttoForManed(ansatt, year, monthIndex) {
  if (!ansatt || ansatt.aktiv === false) return 0;
  if (!erAktivIManed(ansatt, year, monthIndex)) return 0;

  if (ansatt.lonnstype === "fast") {
    const prosent = stillingsprosentForManed(ansatt, year, monthIndex);
    return ((Number(ansatt.manedslonnVed100Prosent) || 0) * prosent) / 100;
  }
  return (Number(ansatt.timelonn) || 0) * (Number(ansatt.forventedeTimerPerManed) || 0);
}

// Arbeidsgiveravgift beregnes av avgiftspliktig beløp, som inkluderer
// feriepenger — derfor legges feriepenger til før satsen anvendes.
export function beregnManedskostnad(ansatt, year, monthIndex, innstilling) {
  const brutto = bruttoForManed(ansatt, year, monthIndex);
  const feriepengerProsent = Number(innstilling?.feriepengerProsent) || 0;
  const otpProsent = Number(innstilling?.otpProsent) || 0;
  const arbeidsgiveravgiftProsent = Number(innstilling?.arbeidsgiveravgiftProsent) || 0;

  const feriepenger = (brutto * feriepengerProsent) / 100;
  const otp = (brutto * otpProsent) / 100;
  const arbeidsgiveravgift = ((brutto + feriepenger) * arbeidsgiveravgiftProsent) / 100;
  const total = brutto + feriepenger + otp + arbeidsgiveravgift;

  return { brutto, feriepenger, otp, arbeidsgiveravgift, total };
}

export function summerManed(ansatte, year, monthIndex, innstilling) {
  const sum = { brutto: 0, feriepenger: 0, otp: 0, arbeidsgiveravgift: 0, total: 0 };
  for (const ansatt of ansatte || []) {
    if (ansatt.aktiv === false) continue;
    const k = beregnManedskostnad(ansatt, year, monthIndex, innstilling);
    sum.brutto += k.brutto;
    sum.feriepenger += k.feriepenger;
    sum.otp += k.otp;
    sum.arbeidsgiveravgift += k.arbeidsgiveravgift;
    sum.total += k.total;
  }
  return sum;
}

export const MONTH_NAMES_LONN = [
  "Januar", "Februar", "Mars", "April", "Mai", "Juni",
  "Juli", "August", "September", "Oktober", "November", "Desember",
];
